import React, { useEffect, useState } from 'react'
import GoKids from '../../services/GoKids';

import PageTitle from '../../components/PageTitle';




export default function Home() {

  const [maetorista, setMaetorista] = useState({ cidades: [] })
  const [familia, setFamilia] = useState({})




  useEffect(() => {
    GetData()

    loadFromApi()
  }, [])



  async function loadFromApi() {

    let families = await GoKids.listFamilies()
    let requestC = await GoKids.countFamilyRequest()


    let driver = []




    console.log(families, requestC);


    families.map(function (a, i) {
      if (a.driverCount > 0) {
        driver.push(a)
      }
    })

    console.log(driver)
    setFamilia({ 'solicitacao': requestC, 'atendidas': driver.length, 'user': families.length })




  }







  async function GetData() {
    const [drivers, requestCount] = await Promise.all([GoKids.listDrivers(), GoKids.countRequests()]);
    console.log(drivers, requestCount)

    let notAllowed = []
    let allowed = []
    let inReview = []

    drivers.map(function (e) {
      switch (e.status) {

        case 'allowed':
          allowed.push(e)
          break;
        case 'not-allowed':
          notAllowed.push(e)
          break;
        case 'in-review':
          inReview.push(e)
          break;
        default:
          break;
      }
    });

    console.log(notAllowed, allowed, inReview)



    const estados = allowed.reduce((obj, { state, city }) => {
      if (!obj[state]) obj[state] = [];
      obj[state].push(city);
      return obj;
    }, {});

    console.log('estatdos', estados);




    const cidades = Object.keys(estados).map(state => {

      let uniqueCount = estados[state];
      var count = {};
      uniqueCount.forEach(function (i) { count[i] = (count[i] || 0) + 1; });
      console.log(count);
      const cits = Object.keys(count).map(state => {

        console.log(state)
        return {
          cidade: state,
          total: count[state]
        }
      })

      return {
        state,
        cidades: cits
      };
    });
    console.log(cidades);







    const totais = drivers.reduce((obj, { state, city }) => {
      if (!obj[state]) obj[state] = [];
      obj[state].push(city);
      return obj;
    }, {});

    console.log('totais', totais);


    const cidadestotais = Object.keys(totais).map(state => {

      let uniqueCount = totais[state];
      var count = {};
      uniqueCount.forEach(function (i) { count[i] = (count[i] || 0) + 1; });
      console.log(count);
      const cits = Object.keys(count).map(state => {

        console.log(state)
        return {
          cidade: state,
          total: count[state]
        }
      })

      return {
        state,
        cidades: cits
      };
    });
    console.log(`cidadestotais`, cidadestotais);











    setMaetorista({ notAllowed, allowed, inReview, cidades: cidades[0] })

    console.log(maetorista)


  }

  useEffect(() => {
    console.log(maetorista)
  }, [maetorista])

  function groupBy(objectArray, property) {
    return objectArray.reduce((acc, obj) => {
      let key = obj[property];

      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {})
  }




  return (
    <React.Fragment>
      <PageTitle title="DashBoard" />

      <div style={{ display: 'flex', flexWrap:'wrap'}}>


        <div className="card card-form" style={styles.content}>
          <h4 className="form-subheader">Maetoristas</h4>

          <div style={styles.area}>

            {maetorista.allowed && <div>

              <b>Aprovada: </b> {maetorista.allowed.length} <br />
              <b>Analisando: </b> {maetorista.notAllowed.length}<br />
              <b>Recusado: </b> {maetorista.inReview.length}<br />

              <b>Cidades: </b>
              {maetorista.cidades.cidades.map(function (a, i) {
                return <div style={{ marginLeft: 10 }}>{a.cidade}: {a.total}</div>
              })}



            </div>}

          </div>



        </div>






        <div className="card card-form" style={styles.content}>
          <h4 className="form-subheader">Familias</h4>
          <div style={styles.area}>

            {familia.atendidas && <div>

              <b>Total de familias cadastradas: </b> {familia.user} <br />
              <b>Sendo atendidas: </b> {familia.atendidas} <br />

              <b>Solicitações abertas: </b> {familia.solicitacao}<br />





            </div>}
          </div>
        </div>


        <div className="card card-form" style={styles.content}>
          <h4 className="form-subheader">Estrutura</h4>
          <div style={styles.area}>

          <div>

              <b>Bando de Dados: </b> MongoDB <br />
              <b>API: </b> NodeJS<br />
              <b>APP Mãetoristas: </b> React-Native<br />
              <b>APP Familia: </b> React-Native<br />

              <b>Servidor: </b> DigitalOcean<br />

              <br /><br />


              <b>Proximas Etapas</b> <br />
              <input type="checkbox" id="scales" name="scales"
         disabled checked/> Link CEP para GOOGLE maps<br />
              <input type="checkbox" id="scales" name="scales"
         disabled/> Exportação de dados para XLSx<br />
              <input type="checkbox" id="scales" name="scales"
         disabled/> Migração para o AWS<br />
           <input type="checkbox" id="scales" name="scales"
         disabled/> separar os servicos (API, Banco de dados)<br />
 <input type="checkbox" id="scales" name="scales"
         disabled/> Atualização da versão do <b>react-native</b><br />



            </div>
          </div>
        </div>



        <div className="card card-form" style={styles.content}>
          <h4 className="form-subheader">Lojas</h4>
          <div style={styles.area}>
       
          <b>APP Familia: </b> <br />
          <b>Android </b> <a href="https://play.google.com/store/apps/details?id=com.kujhy.gokids.family">Link</a> <br />
          <b>Apple </b> <a href="https://apps.apple.com/br/app/gokids-para-família/id1534489442">Link</a> <br />
          <br /><br />
          <b>APP Mãetoristas: </b> <br />
          <b>Android </b> <a href="https://play.google.com/store/apps/details?id=com.kujhy.gokids.driver">Link</a> <br />
          <b>Apple </b><a href="https://apps.apple.com/br/app/gokids-para-mãetoristas/id1505005906">Link</a> <br />
          </div>
        </div>



      </div>


    </React.Fragment>
  )
}


const styles = {
  content: { paddingBottom: 24, width: 500, marginLeft: 20, marginBottom: 40 },
  area: { padding: 20 },

  message: { whiteSpace: 'pre-line' }
};


// WEBPACK FOOTER //
// ./src/screens/dashboard/Home.js